import {apolloClient, gql} from '../graphql';
import {logAndThrowGraphQLErrors} from '../graphql/helpers';

export const syncWithYnab = async (): Promise<void> => {
	const {errors} = await apolloClient.mutate({
		mutation: gql(/* GraphQL */ `
			mutation SyncData {
				syncWithYnab
			}
		`),
	});

	if (errors && errors.length > 0) {
		logAndThrowGraphQLErrors(errors);
	}
};
